define('view/controller/booking/service/ServiceEmptyView',['require','lib/view/LayoutView'],function (require) {

	var LayoutView = require('lib/view/LayoutView');
	
	/**
	 * Service empty view
	 * 
	 * @class ServiceEmptyView
	 */
	return LayoutView.extend({

		template: '#service_empty'
	    
	});
	
});
